import { nextEntryYearMonth } from "@/setsterConfig";
/**
 * Generates a universally unique identifier
 * @returns {string}
 */
function uuidv4() {
  // Generates a UUID
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

/**
 * Sleeps asyncronously for the given duration
 * @param {number} duration in miliseconds
 * @returns
 */
async function sleep(duration) {
  let promise = new Promise((resolve) => {
    setTimeout(() => {
      resolve(undefined);
    }, duration || 1000);
  });
  return promise;
}

/**
 * Converts 24h time into 12h time with AM/PM
 * @param {string} value - Time in the 24 hour format hh:mm:ss
 * @returns {string} A 12 hour formatted time (hh:mm AM/PM)
 */
function convertTo12HourTime(value) {
  var hours = value.slice(0, 2);
  var min = value.slice(3, 5);
  if (hours < 12) {
    return `${hours}:${min} AM`;
  } else if (hours == 12) {
    return `${hours}:${min} PM`;
  } else {
    hours = hours - 12;
    hours = hours < 10 ? `0${hours}` : hours;
    return `${hours}:${min} PM`;
  }
}

/**
     * Checks if a given tour and time conflict with an already chosen slot
     * @param {number} id - service id
     * @param {string} time - time of the chosen service slot
     * @param {number} duration - number of minutes a tour lasts
     * @param {object} selectedTours - currently selected tours
     */
 function checkConflict(id, time, duration, selectedTours) {
  // Ignore already selected time slots
  if (selectedTours.find((o) => o.time == time && o.id == id)) return false;
  let filteredTours = selectedTours.filter((o) => o.id != id);

  // Convert to seconds to check overlapping
  let hour = parseInt(time.slice(0, 2));
  let min = parseInt(time.slice(3, 5));
  let slot_start = hour * 60 + min;
  let slot_end = slot_start + parseInt(duration);

  // Disable conflicting time slots
  let existing = filteredTours.find(function (obj) {
    // Convert to seconds
    let h = parseInt(obj.time.slice(0, 2));
    let m = parseInt(obj.time.slice(3, 5));
    let checked_start = h * 60 + m;
    let checked_end = checked_start + parseInt(obj.duration);

    // disable same hour
    if (h == hour) return true;

    return Math.max(slot_start, checked_start) < Math.min(slot_end, checked_end);
  });

  if (existing) return true;
}

/**
 * Tests for a valid GUID
 */
  function validateGUID(guid) {
    const regex = /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/g;
    return regex.test(guid);
  }


/**
 * Calculate current valid entry year to use
 */
function getEntryYear() {
  let currentYear = new Date().getFullYear() ;
  let currentMonth = new Date().getMonth();
  // Stop asking for current year after July(6).  Note currentMonth index starts at 0 (ie. 0 = Jan, 11 = Dec)
  return currentMonth >= nextEntryYearMonth ? currentYear + 1 : currentYear;
}

export { uuidv4, sleep, convertTo12HourTime, checkConflict, validateGUID, getEntryYear };
